import { render, staticRenderFns } from "./RootLayout.vue?vue&type=template&id=446a2aa5&scoped=true&"
import script from "./RootLayout.vue?vue&type=script&lang=js&"
export * from "./RootLayout.vue?vue&type=script&lang=js&"
import style0 from "./RootLayout.vue?vue&type=style&index=0&id=446a2aa5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "446a2aa5",
  null
  
)

export default component.exports